import PhysiologyReportRepository from '@/shared/http/repositories/socialProject/physiology-report'
import { IsSuccessCode } from '@/shared/utils/API'
import { loading } from '@/shared/utils/UIHelper'
import VueHighcharts from 'vue2-highcharts'

export default {
  components: {
      VueHighcharts
  },

  props: {
    studentId: {
      type: String,
      default: {}
    }
  },

  data: () => ({
    options: {
      chart: {
        type: 'column'
      },
      title: {
        text: 'Rendimento do Aluno'
      },
      subtitle: {
        text: 'Média das Sprints'
      },
      xAxis: {
        type: 'category',
        labels: {
            rotation: -45,
            style: {
                color: '#0d75a3',
                fontSize: '13px',
                fontFamily: 'Verdana, sans-serif'
            }
        }
      },
      yAxis: {
        min: 0,
        title: {
            text: 'Segundos(s)'
        }
      },
      legend: {
        enabled: false
      },
      tooltip: {
        pointFormat: 'Tempo dê: <b>{point.y:.1f}(s)</b>'
      },
      series: [{
        name: 'Médias',
        dataLabels: {
            enabled: true,
            rotation: -90,
            color: '#FFFFFF',
            align: 'right',
            format: '{point.y:.1f}', // one decimal
            y: 10, // 10 pixels down from the top
            style: {
                fontSize: '13px',
                fontFamily: 'Verdana, sans-serif',
            }
        }
      }]
    }
  }),

  watch: {
    studentId: {
      handler: function (value) {
        if (value) {
          this.loadChargeData(value)
        }
      },
      immediate: true
    }
  },

  methods: {
    loadChargeData(id) {
      loading.push()
      PhysiologyReportRepository.GetAllAvgStudentByStudentId(id)
      .then(response => {

        if(!IsSuccessCode){
          loading.pop()
          return Promise.reject()
        }

        const student = response.data.data

        let seasonName = []
        let studentSprintAverage = []
        
        if (student.studentAvgsSprint.length != 0) {
          seasonName = student.seasonName
          studentSprintAverage = student.studentAvgsSprint.filter(c => c != null)
        }

        setTimeout(() => {
          this.$refs.lineCharts.chart.update({
            xAxis: {
              categories: seasonName,
              text: null
            },
            series: [{
              name: 'Tempo',
              data: studentSprintAverage
            }],
            title: {
              text: 'Rendimento do Aluno',
              align: 'center'
            },
            subtitle: {
              text: 'Tempo Total em Segundos',
              align: 'center'
            }
          })

          loading.pop()
        }, 1300)
      })
      .catch(e => {
        loading.pop()
        console.log(`Erro ao tentar obter os dados para o gráfico de rendimentos do aluno: \n ${e}`)
      })
    }
  }
}